import Service from './Service';

const PHONE_MASK_SERVICE_BASE_URL = 'userapi/public/v2/phone-masks';

class PhoneMaskService extends Service {
  getAllEnabledPhoneMasks (creditorId) {
    return this.instance.get(`${PHONE_MASK_SERVICE_BASE_URL}/enabled`, {
      params: {
        creditorId: creditorId
      }
    });
  }
}

export default new PhoneMaskService();
